import * as yup from 'yup';

import { FORM_FIELDS } from '@constants/form';

export const UPDATE_LEAVE = FORM_FIELDS.UPDATE_LEAVE;

export const updateLeaveFormValidation = yup.object().shape({
  [UPDATE_LEAVE.TAKEN_LEAVE]: yup.number(),
});

export const updateLeaveFormValidationSchema = yup.object().shape({
  updateLeaveFormValidation: yup.array().of(updateLeaveFormValidation),
});

export interface UpdateLeaveFormValidationDataType {
  updateLeaveFormValidation: yup.InferType<typeof updateLeaveFormValidation>[];
}